import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReorderPlanReviewCategoriesMutationVariables = Types.Exact<{
  updates: Array<Types.Plan_Review_Categories_Updates> | Types.Plan_Review_Categories_Updates;
}>;


export type ReorderPlanReviewCategoriesMutation = { __typename?: 'mutation_root', update_plan_review_categories_many?: Array<{ __typename?: 'plan_review_categories_mutation_response', affected_rows: number } | null> | null };


export const ReorderPlanReviewCategoriesDocument = gql`
    mutation reorderPlanReviewCategories($updates: [plan_review_categories_updates!]!) {
  update_plan_review_categories_many(updates: $updates) {
    affected_rows
  }
}
    `;
export type ReorderPlanReviewCategoriesMutationFn = Apollo.MutationFunction<ReorderPlanReviewCategoriesMutation, ReorderPlanReviewCategoriesMutationVariables>;

/**
 * __useReorderPlanReviewCategoriesMutation__
 *
 * To run a mutation, you first call `useReorderPlanReviewCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPlanReviewCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPlanReviewCategoriesMutation, { data, loading, error }] = useReorderPlanReviewCategoriesMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useReorderPlanReviewCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderPlanReviewCategoriesMutation, ReorderPlanReviewCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderPlanReviewCategoriesMutation, ReorderPlanReviewCategoriesMutationVariables>(ReorderPlanReviewCategoriesDocument, options);
      }
export type ReorderPlanReviewCategoriesMutationHookResult = ReturnType<typeof useReorderPlanReviewCategoriesMutation>;
export type ReorderPlanReviewCategoriesMutationResult = Apollo.MutationResult<ReorderPlanReviewCategoriesMutation>;
export type ReorderPlanReviewCategoriesMutationOptions = Apollo.BaseMutationOptions<ReorderPlanReviewCategoriesMutation, ReorderPlanReviewCategoriesMutationVariables>;